/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useRBAC, PERMISSION } from "cms/auth/hooks/use-RBAC";
import { CircularProgress } from "@mui/material";
// import { Logger } from "cms/utils/log/logger";

/**
 * PermissionGuard
 *
 * @param {string} props.message
 * @param {boolean} props.showMessage
 * @param {array|string} props.permission
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const PermissionGuard = (props) => {

    const children = props?.children;
    const _message = props?.message;
    const permission = props?.permission ?? [PERMISSION.GENERAL]; // accepts a single permission or a list
    // const location = props?.location, // used to log the location where the check was applied

    const [granted, setGranted] = useState(false);
    // const defaultMessage = <p>You do not have the required role to access this functionality</p>
    // const message = _message ? _message : defaultMessage;

    const {
        checkPermission,
        account_roles,
        permissionsReady,
        permission_roles,
        // PERMISSION
    } = useRBAC();

    const message = _message;
    const showMessage = !!message;

    useEffect(() => {
        const check = async (permission) => {
            if (account_roles) {
                const allowed = await checkPermission(permission);
                // console.log(`%c[PermissionGuard] [allowed:${allowed}] [location:${location}] ${permission} [permissionsReady:${permissionsReady}]`, 'color: limegreen');
                // Logger.debug(`[PermissionGuard] allowed:${allowed}`);
                setGranted(allowed);
            }
        }
        check(permission);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionsReady, permission]);

    if ((permission_roles?.length < 1)) {
        return (
            <div style={{
                display: "flex", flexDirection: "row",
                justifyContent: "center", alignItems: "center",
                padding: "16px", minHeight: "60px",
            }}
            ><CircularProgress color="secondary"/></div>
        );
    } else if (!granted && !showMessage) {
        // console.log(`[PermissionGuard] not granted, ${location} ${JSON.stringify(permission)}`)
        return null;
    } else if (!granted && showMessage) {
        // console.log(`[PermissionGuard] not granted with message, ${location} ${JSON.stringify(permission)}`)
        return <div className='role-permission-not-granted-message'>{message}</div>;
    } else {
        // console.log(`[PermissionGuard] granted: ${location} ${JSON.stringify(permission)}`)
        return (<>{children}</>);
    }
};

export { PermissionGuard, PERMISSION };
